import { db } from '@/api/firebase';
import { useMainContext } from '@/context/main-context';
import {
  addDoc,
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  startAfter,
  where,
} from 'firebase/firestore';
import { useEffect, useState } from 'react';

export function useLogs(perPage = 10) {
  const { uid, activeBranchId } = useMainContext();
  const [logs, setLogs] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const addLog = async (type, context, action, details = null) => {
    if (!uid) return;
    const logsRef = collection(db, `users/${uid}/logs`);
    await addDoc(logsRef, {
      type,
      context,
      action,
      details,
      branchId: activeBranchId,
      timestamp: serverTimestamp(),
      uid,
    });
  };

  const fetchLogs = async () => {
    setLoading(true);

    let q = query(
      collection(db, `users/${uid}/logs`),
      // where('branchId', '==', activeBranchId),
      orderBy('timestamp', 'desc'),
      limit(perPage)
    );

    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const lastVisible = snapshot.docs[snapshot.docs.length - 1];
      setLastDoc(lastVisible);
      setLogs(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      setHasMore(snapshot.docs.length === perPage);
    } else {
      setHasMore(false);
    }

    setLoading(false);
  };

  const loadMore = async () => {
    if (!lastDoc) return;

    setLoading(true);

    let q = query(
      collection(db, `users/${uid}/logs`),
      where('branchId', '==', activeBranchId), // filter qo'shildi
      orderBy('timestamp', 'desc'),
      startAfter(lastDoc),
      limit(perPage)
    );

    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const lastVisible = snapshot.docs[snapshot.docs.length - 1];
      setLastDoc(lastVisible);
      setLogs((prev) => [
        ...prev,
        ...snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
      ]);
      setHasMore(snapshot.docs.length === perPage);
    } else {
      setHasMore(false);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchLogs();
  }, [activeBranchId]);

  return { logs, addLog, loading, hasMore, loadMore };
}
